"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  "button.delete": "Delete",
  "button.download": "Download",
  "button.close": "Close",
  "button.submit": "Submit",
  "button.help": "Help",
  "button.rotate": "Rotate",
  "button.bookmarks": "Bookmarks",
  "button.print": "Print",
  "preview.nextDocument": "Next Document",
  "preview.notAvailable": "Preview not available for this file type.",
  "preview.passwordRequired": "Password Required",
  "preview.passwordDesc": "Enter a password to access this document.",
  "preview.previousDocument": "Previous Document",
  "loading": "Loading",
  "page": "Page"
};
exports.default = _default;
